import { CSpinner } from '@coreui/react-pro';
import React from 'react';

export const TableLoader = () => {
    return (
        <div className="ag-overlay-loading-center" role="presentation">
            <CSpinner></CSpinner>
            <div aria-live="polite" aria-atomic="true">
                Fetching Data
            </div>
        </div>
    );
};